/**
 * Design tokens. Art direction is a hybrid of military-industrial and high-tech
 * (DECISIONS.md #9): dark steel neutrals with a single hot accent.
 */
export const colors = {
    background: '#0b0d10',
    surface: '#14181d',
    surfaceRaised: '#1c2229',
    border: '#2a323c',
    text: '#e6e9ed',
    textMuted: '#8a94a0',
    accent: '#ff7a1a',
    accentText: '#0b0d10',
    danger: '#ff4d4f',
    success: '#3ddc84',
    warning: '#ffc53d',
};
export const fonts = {
    ui: "'Segoe UI', system-ui, -apple-system, sans-serif",
    mono: "'Cascadia Mono', 'JetBrains Mono', Consolas, monospace",
};
export const spacing = {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '40px',
};
export const radii = {
    sm: '4px',
    md: '8px',
};
//# sourceMappingURL=tokens.js.map